import React, { useEffect, useState } from 'react';
import styles from './calculatedRankOverlay.module.scss';
import calculateRank, { Result } from '../../../helpers/calculateRank';
import RankDelta from '../../common/rankDelta/rankDelta';
import { t } from '@base/utils/helpers';

export default function CalculatedRankOverlay(props: {
  myRank?: number;
  hisRank: number;
}) {
  const [res, setRes] = useState<Result>();

  useEffect(() => {
    if (props.myRank) {
      const res = calculateRank(props.myRank, props.hisRank);
      setRes(res);
    }
  }, [props.myRank, props.hisRank]);

  if (!props.myRank) return <span>{t('you_are_not_rank_player')}</span>;

  return (
    <div className={styles.calcResult}>
      <div>
        <span>{t('you_win')}</span>
        <RankDelta start={res?.prevRank} finish={res?.winRank} />
      </div>
      <div>
        <span>{t('you_lose')}</span>
        <RankDelta start={res?.prevRank} finish={res?.loseRank} />
      </div>
    </div>
  );
}
